import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { ImagePicker } from 'containers/misc'
import { MaterialModal } from 'components/layout'
import { Textarea } from 'components/fields'
import { Note } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiDashboard } from 'helpers/decorators/api'
import validate from './complete-aj-pe.validation'

@form({
  form: 'CompletePracticeJourney',
  disableHook: true,
  validate
})
@apiDashboard.apiAdventurousJourney({
  refreshKey: 'awardId',
  loaders: ['completion']
})
class CompleteParticipantEventJourney extends Component {
  static propTypes = {
    onCompleteAJParticipantEvent: PropTypes.func,
    onAfterSubmit: PropTypes.func,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    id: PropTypes.number,
    completionStatus: PropTypes.object,
    colorClass: PropTypes.string,
    submitDisabled: PropTypes.bool
  }

  handleSubmit = fields => {
    this.props
      .onCompleteAJParticipantEvent(this.props.id, fields, {
        resetForm: this.props.reset
      })
      .then(() => {
        setTimeout(() => {
          this.props.onAfterSubmit()
        }, 500)
      })
  }

  render() {
    const {
      completionStatus,
      handleSubmit,
      colorClass,
      submitDisabled
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Note margin="20px 0 30px">
          <FormattedMessage
            id="label.after_your_journey_describe"
            defaultMessage="After your Journey describe your observations in a few sentences."
          />
        </Note>

        <Textarea
          name="observations"
          label="Journey Observations"
          intlKey="label.journey_observations"
        />

        <ImagePicker name="fileUrls" />

        <MaterialModal.Footer
          action="Save report"
          actionKey="button.save_report"
          colorClass={colorClass}
          insideContent
          disabled={submitDisabled}
          isLoading={get(completionStatus, 'loading')}
        />
      </form>
    )
  }
}

export default CompleteParticipantEventJourney
